export default [
    {
        id: 1,
        name_ca: 'Molt alta',
        name_en: 'Very high',
        name_es: 'Muy alta'
    },
    {
        id: 2,
        name_ca: 'Alta',
        name_en: 'High',
        name_es: 'Alta'
    },
    {
        id: 3,
        name_ca: 'Mitjana-alta',
        name_en: 'Medium-high',
        name_es: 'Media alta'
    },
    {
        id: 4,
        name_ca: 'Mitjana',
        name_en: 'Medium',
        name_es: 'Media'
    },
    {
        id: 5,
        name_ca: 'Mitjana-baixa',
        name_en: 'Medium-low',
        name_es: 'Media baja'
    },
    {
        id: 6,
        name_ca: 'Baixa',
        name_en: 'Low',
        name_es: 'Baja'
    },
    {
        id: 7,
        name_ca: 'Molt baixa',
        name_en: 'Very low',
        name_es: 'Muy baja'
    }
]





// WEBPACK FOOTER //
// ./src/options/quality_of_finishes.js